import { ValidationMode } from 'react-hook-form';

export const formConfigBase = {
  mode: 'onBlur' as keyof ValidationMode,
  shouldFocusError: false,
};
